export default `

    @font-face {
        font-family: 'Basis Grotesque Pro';
        font-style: normal;
        font-weight: 300;
        src: url('/assets/fonts/basis-grotesque-300.woff2'); /* IE9 Compat Modes */
        src: local('Basis Grotesque Pro Light'), local('BasisGrotesque300'),
            url('/assets/fonts/basis-grotesque-300.woff2') format('woff2'), /* Super Modern Browsers */
            url('/assets/fonts/basis-grotesque-300.woff') format('woff'), /* Modern Browsers */
            url('/assets/fonts/basis-grotesque-300.ttf') format('truetype'), /* Safari, Android, iOS */
    }

    @font-face {
        font-family: 'Basis Grotesque Pro';
        font-style: normal;
        font-weight: 400;
        src: url('/assets/fonts/basis-grotesque-400.woff2'); /* IE9 Compat Modes */
        src: local('Basis Grotesque Pro Regular'), local('BasisGrotesque400'),
            url('/assets/fonts/basis-grotesque-400.woff2') format('woff2'), /* Super Modern Browsers */
            url('/assets/fonts/basis-grotesque-400.woff') format('woff'), /* Modern Browsers */
            url('/assets/fonts/basis-grotesque-400.ttf') format('truetype'), /* Safari, Android, iOS */
    }

    @font-face {
        font-family: 'Basis Grotesque Pro';
        font-style: normal;
        font-weight: 600;
        src: url('/assets/fonts/basis-grotesque-600.woff2'); /* IE9 Compat Modes */
        src: local('Basis Grotesque Pro Bold'), local('BasisGrotesque600'),
            url('/assets/fonts/basis-grotesque-600.woff2') format('woff2'), /* Super Modern Browsers */
            url('/assets/fonts/basis-grotesque-600.woff') format('woff'), /* Modern Browsers */
            url('/assets/fonts/basis-grotesque-600.ttf') format('truetype'), /* Safari, Android, iOS */
    }

`
